import auth0 from '../../services/auth0'
import store from '../../store'
import debug from '../../helpers/debug'
import { AUTH_CONFIG } from './auth0-variables'

const renewAndStoreToken = async () => {
  return new Promise((resolve, reject) => {
    auth0.renewAuth(
      {
        audience: AUTH_CONFIG.audience,
        scope: AUTH_CONFIG.scope,
      },
      (err, result) => {
        if (err) {
          debug('debug: renewAuth error', err)
          reject(err)
        } else {
          if (result !== null) {
            debug('debug: renewAuth result', result)
            store.dispatch('storeToken', result).then(() => {
              resolve(result)
            })
          }
        }
      }
    )
  })
}

function readExpiresAtMs(): number {
  const raw = localStorage.getItem('expires_at')
  if (!raw) return 0

  try {
    return Number(JSON.parse(raw))
  } catch {
    return Number(raw)
  }
}

const renewExpiringToken = async () => {
  const expTime = readExpiresAtMs()
  const secondsLeft = expTime / 1000 - Date.now() / 1000

  debug('debug: secondsLeft', secondsLeft)

  if (secondsLeft <= 0) {
    debug('debug: renewing token')
    try {
      await renewAndStoreToken()
    } catch (error) {
      debug('debug: renew token failed', error)
    }
  }
}

export default renewExpiringToken
